import { baseSplitApiCrud as api } from "./config/baseApiCrud";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    advancedSearch: build.query<
      AdvancedSearchApiResponse,
      AdvancedSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/search`,
        headers: { Authorization: queryArg.authorization },
        params: {
          term: queryArg.term,
          subjectType: queryArg.subjectType,
          name: queryArg.name,
          lastname: queryArg.lastname,
          fiscalCode: queryArg.fiscalCode,
          phone: queryArg.phone,
          email: queryArg.email,
          businessName: queryArg.businessName,
          pIva: queryArg.pIva,
          plate: queryArg.plate,
          policyNumber: queryArg.policyNumber,
          Insurance: queryArg.insurance,
          claimNumber: queryArg.claimNumber,
        },
      }),
    }),
    createPolicy: build.mutation<CreatePolicyApiResponse, CreatePolicyApiArg>({
      query: (queryArg) => ({
        url: `/policies`,
        method: "POST",
        body: queryArg.policy,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    createClaim: build.mutation<CreateClaimApiResponse, CreateClaimApiArg>({
      query: (queryArg) => ({
        url: `/claims`,
        method: "POST",
        body: queryArg.claim,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    readClaim: build.query<ReadClaimApiResponse, ReadClaimApiArg>({
      query: (queryArg) => ({
        url: `/claims/${queryArg.id}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    updateClaim: build.mutation<UpdateClaimApiResponse, UpdateClaimApiArg>({
      query: (queryArg) => ({
        url: `/claims/${queryArg.id}`,
        method: "PUT",
        body: queryArg.claim,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    deleteClaim: build.mutation<DeleteClaimApiResponse, DeleteClaimApiArg>({
      query: (queryArg) => ({
        url: `/claims/${queryArg.id}`,
        method: "DELETE",
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getPracticesSummary: build.query<
      GetPracticesSummaryApiResponse,
      GetPracticesSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/practicesSummary/${queryArg.idTenant}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    updatePracticesSummary: build.mutation<
      UpdatePracticesSummaryApiResponse,
      UpdatePracticesSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/practicesSummary/${queryArg.idTenant}`,
        method: "PUT",
        body: queryArg.dashboardSummary,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getPracticesStatus: build.query<
      GetPracticesStatusApiResponse,
      GetPracticesStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/processingstatus`,
        headers: { Authorization: queryArg.authorization },
        params: {
          practices: queryArg.practices,
          activeRole: queryArg.activeRole,
        },
      }),
    }),
    updatePracticesStatus: build.mutation<
      UpdatePracticesStatusApiResponse,
      UpdatePracticesStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/processingstatus`,
        method: "PUT",
        body: queryArg.practicesProcessingStatus,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getPracticesD2SummaryByTenant: build.query<
      GetPracticesD2SummaryByTenantApiResponse,
      GetPracticesD2SummaryByTenantApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/summary/d2/${queryArg.idTenant}`,
        headers: { Authorization: queryArg.authorization },
        params: {
          isDocumental: queryArg.isDocumental,
          appraiserType: queryArg.appraiserType,
          hasAppointment: queryArg.hasAppointment,
          practiceStatus: queryArg.practiceStatus,
          practiceStatusAggr: queryArg.practiceStatusAggr,
        },
      }),
    }),
    updateD2PracticesSummary: build.mutation<
      UpdateD2PracticesSummaryApiResponse,
      UpdateD2PracticesSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/summary/d2/${queryArg.idTenant}`,
        method: "PUT",
        body: queryArg.dashboardD2Summary,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getPracticesE2Summary: build.query<
      GetPracticesE2SummaryApiResponse,
      GetPracticesE2SummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/practicesE2Summary/${queryArg.idTenant}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    updatePracticesE2Summary: build.mutation<
      UpdatePracticesE2SummaryApiResponse,
      UpdatePracticesE2SummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/practicesE2Summary/${queryArg.idTenant}`,
        method: "PUT",
        body: queryArg.dashboardE2Summary,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getF1PracticesSummaryByTenant: build.query<
      GetF1PracticesSummaryByTenantApiResponse,
      GetF1PracticesSummaryByTenantApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/summary/f1/${queryArg.idTenant}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    fakeUpdateF1PracticesSummaryByTenant: build.mutation<
      FakeUpdateF1PracticesSummaryByTenantApiResponse,
      FakeUpdateF1PracticesSummaryByTenantApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/summary/f1/${queryArg.idTenant}`,
        method: "PUT",
        body: queryArg.dashboardF1Summary,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getE4PracticesSummaryByTenant: build.query<
      GetE4PracticesSummaryByTenantApiResponse,
      GetE4PracticesSummaryByTenantApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/summary/E4/${queryArg.idTenant}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    fakeUpdateE4PracticesSummaryByTenant: build.mutation<
      FakeUpdateE4PracticesSummaryByTenantApiResponse,
      FakeUpdateE4PracticesSummaryByTenantApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/summary/E4/${queryArg.idTenant}`,
        method: "PUT",
        body: queryArg.dashboardE4Summary,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getE1PracticesSummaryByTenant: build.query<
      GetE1PracticesSummaryByTenantApiResponse,
      GetE1PracticesSummaryByTenantApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/summary/E1/${queryArg.idTenant}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    fakeUpdateE1PracticesSummaryByTenant: build.mutation<
      FakeUpdateE1PracticesSummaryByTenantApiResponse,
      FakeUpdateE1PracticesSummaryByTenantApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/summary/E1/${queryArg.idTenant}`,
        method: "PUT",
        body: queryArg.dashboardE1Summary,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getPracticeDetail: build.query<
      GetPracticeDetailApiResponse,
      GetPracticeDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/practiceDetail/${queryArg.id}`,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    updatePracticeDetail: build.mutation<
      UpdatePracticeDetailApiResponse,
      UpdatePracticeDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/practiceDetail/${queryArg.id}`,
        method: "PUT",
        body: queryArg.writeOnlyPractice,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    practiceBlock: build.mutation<
      PracticeBlockApiResponse,
      PracticeBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/practiceBlock/${queryArg.id}`,
        method: "PUT",
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    practiceUnblock: build.mutation<
      PracticeUnblockApiResponse,
      PracticeUnblockApiArg
    >({
      query: (queryArg) => ({
        url: `/practiceUnblock/${queryArg.id}`,
        method: "PUT",
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getUserCommunicationsList: build.query<
      GetUserCommunicationsListApiResponse,
      GetUserCommunicationsListApiArg
    >({
      query: (queryArg) => ({
        url: `/communications/`,
        headers: { Authorization: queryArg.authorization },
        params: {
          senderType: queryArg.senderType,
          tenants: queryArg.tenants,
          categoryCode: queryArg.categoryCode,
          statusCode: queryArg.statusCode,
        },
      }),
    }),
    createCommunication: build.mutation<
      CreateCommunicationApiResponse,
      CreateCommunicationApiArg
    >({
      query: (queryArg) => ({
        url: `/communications/`,
        method: "POST",
        body: queryArg.communication,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getAppraisersList: build.query<
      GetAppraisersListApiResponse,
      GetAppraisersListApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/appraisers-list`,
        headers: { Authorization: queryArg.authorization },
        params: {
          practiceId: queryArg.practiceId,
          tenantsId: queryArg.tenantsId,
          activeRole: queryArg.activeRole,
        },
      }),
    }),
    updateAppraisersList: build.mutation<
      UpdateAppraisersListApiResponse,
      UpdateAppraisersListApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/appraisers-list`,
        method: "PUT",
        body: queryArg.practiceActivityAppraiser,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    assignAppraiser: build.mutation<
      AssignAppraiserApiResponse,
      AssignAppraiserApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/assign-appraiser`,
        method: "POST",
        body: queryArg.assignmentData,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    suspendOrCancelPractice: build.mutation<
      SuspendOrCancelPracticeApiResponse,
      SuspendOrCancelPracticeApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/suspend-cancel-practice`,
        method: "POST",
        body: queryArg.suspendOrCancelData,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    restorePractice: build.mutation<
      RestorePracticeApiResponse,
      RestorePracticeApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/restore-practice`,
        method: "POST",
        body: queryArg.restorePracticeData,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    createPracticeNote: build.mutation<
      CreatePracticeNoteApiResponse,
      CreatePracticeNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/notes`,
        method: "POST",
        body: queryArg.practiceNote,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    updatePracticeNote: build.mutation<
      UpdatePracticeNoteApiResponse,
      UpdatePracticeNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/notes`,
        method: "PUT",
        body: queryArg.practiceNote,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    deletePracticeNote: build.mutation<
      DeletePracticeNoteApiResponse,
      DeletePracticeNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/notes/${queryArg.id}`,
        method: "DELETE",
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getPracticeNotes: build.query<
      GetPracticeNotesApiResponse,
      GetPracticeNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/notes-list/${queryArg.idPractice}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    createPracticeAppointment: build.mutation<
      CreatePracticeAppointmentApiResponse,
      CreatePracticeAppointmentApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/appointment`,
        method: "POST",
        body: queryArg.practiceAppointment,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    acceptPracticeAssignment: build.mutation<
      AcceptPracticeAssignmentApiResponse,
      AcceptPracticeAssignmentApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/accept-assignment/${queryArg.idPractice}`,
        method: "POST",
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    setOutOfCoverageArea: build.mutation<
      SetOutOfCoverageAreaApiResponse,
      SetOutOfCoverageAreaApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/set-out-of-coverage-area/${queryArg.idPractice}`,
        method: "POST",
        body: queryArg.outOfCoverageAppraisalSubject,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    updatePracticeRates: build.mutation<
      UpdatePracticeRatesApiResponse,
      UpdatePracticeRatesApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/rate/${queryArg.idPractice}`,
        method: "PUT",
        body: queryArg.practiceRate,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    updatePracticeFees: build.mutation<
      UpdatePracticeFeesApiResponse,
      UpdatePracticeFeesApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/fee/${queryArg.idPractice}`,
        method: "PUT",
        body: queryArg.practiceFee,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    getDocumentTypes: build.query<
      GetDocumentTypesApiResponse,
      GetDocumentTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-documents/document-types/`,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    uploadPracticeDocument: build.mutation<
      UploadPracticeDocumentApiResponse,
      UploadPracticeDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-documents/${queryArg.id}`,
        method: "POST",
        body: queryArg.practiceDocument,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getIniFile: build.query<GetIniFileApiResponse, GetIniFileApiArg>({
      query: (queryArg) => ({
        url: `/practice-documents/get-ini/${queryArg.id}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getConservativeAgreementFile: build.query<
      GetConservativeAgreementFileApiResponse,
      GetConservativeAgreementFileApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-documents/get-conservative-agreement/${queryArg.id}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    deleteDocumentAttachment: build.mutation<
      DeleteDocumentAttachmentApiResponse,
      DeleteDocumentAttachmentApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-documents/attachments/${queryArg.id}`,
        method: "DELETE",
        headers: { Authorization: queryArg.authorization },
        params: { idAttachment: queryArg.idAttachment },
      }),
    }),
    getAllPracticeDocuments: build.query<
      GetAllPracticeDocumentsApiResponse,
      GetAllPracticeDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-documents/all-documents/${queryArg.id}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getPracticeHistory: build.query<
      GetPracticeHistoryApiResponse,
      GetPracticeHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-history/${queryArg.idPractice}`,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    fakeUpdatePracticeHistory: build.mutation<
      FakeUpdatePracticeHistoryApiResponse,
      FakeUpdatePracticeHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-history/${queryArg.idPractice}`,
        method: "PUT",
        body: queryArg.practiceHistory,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getAllPracticeRequests: build.query<
      GetAllPracticeRequestsApiResponse,
      GetAllPracticeRequestsApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-requests/${queryArg.id}`,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    createPracticeRequest: build.mutation<
      CreatePracticeRequestApiResponse,
      CreatePracticeRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-requests/${queryArg.id}`,
        method: "POST",
        body: queryArg.secondaryPracticeRequest,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    getRequestList: build.query<
      GetRequestListApiResponse,
      GetRequestListApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-requests-list/`,
        headers: { Authorization: queryArg.authorization },
        params: {
          lastMessageSenderType: queryArg.lastMessageSenderType,
          lastMessageReceiverType: queryArg.lastMessageReceiverType,
          tenants: queryArg.tenants,
          categoryCode: queryArg.categoryCode,
          statusCode: queryArg.statusCode,
          activeRole: queryArg.activeRole,
        },
      }),
    }),
    getPracticeRequest: build.query<
      GetPracticeRequestApiResponse,
      GetPracticeRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-requests/requests/${queryArg.id}`,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    closeRequest: build.mutation<CloseRequestApiResponse, CloseRequestApiArg>({
      query: (queryArg) => ({
        url: `/practice-requests/requests/${queryArg.id}/close/`,
        method: "PUT",
        body: queryArg.requestMessage,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    forwardRequest: build.mutation<
      ForwardRequestApiResponse,
      ForwardRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-requests/requests/${queryArg.id}/forward`,
        method: "PUT",
        body: queryArg.requestMessage,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    replyToRequestMessage: build.mutation<
      ReplyToRequestMessageApiResponse,
      ReplyToRequestMessageApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-requests/requests/${queryArg.id}/reply`,
        method: "POST",
        body: queryArg.requestMessage,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    confirmRequestClosureCheck: build.mutation<
      ConfirmRequestClosureCheckApiResponse,
      ConfirmRequestClosureCheckApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-requests/requests/${queryArg.id}/confirm-check`,
        method: "POST",
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    getAllRequestCategoryByUserRole: build.query<
      GetAllRequestCategoryByUserRoleApiResponse,
      GetAllRequestCategoryByUserRoleApiArg
    >({
      query: (queryArg) => ({
        url: `/practices-requests/categories`,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    searchPracticesBo: build.mutation<
      SearchPracticesBoApiResponse,
      SearchPracticesBoApiArg
    >({
      query: (queryArg) => ({
        url: `/search-practices/bo`,
        method: "POST",
        body: queryArg.searchPracticesParams,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    searchPracticesAppraiser: build.mutation<
      SearchPracticesAppraiserApiResponse,
      SearchPracticesAppraiserApiArg
    >({
      query: (queryArg) => ({
        url: `/search-practices/appraiser`,
        method: "POST",
        body: queryArg.searchPracticesParams,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    updateAppraisalLocation: build.mutation<
      UpdateAppraisalLocationApiResponse,
      UpdateAppraisalLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-detail/appraisal-location/${queryArg.idPractice}`,
        method: "POST",
        body: queryArg.appraisalSubject,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    generateCongruityReport: build.mutation<
      GenerateCongruityReportApiResponse,
      GenerateCongruityReportApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/generate-congruity-report/${queryArg.id}`,
        method: "POST",
        body: queryArg.congruityReport,
        headers: { Authorization: queryArg.authorization },
        params: { version: queryArg.version },
      }),
    }),
    uploadAdz: build.mutation<UploadAdzApiResponse, UploadAdzApiArg>({
      query: (queryArg) => ({
        url: `/practice-activities/upload-adz/${queryArg.id}`,
        method: "POST",
        body: queryArg.adzUpload,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    finalisePractice: build.mutation<
      FinalisePracticeApiResponse,
      FinalisePracticeApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/finalise/${queryArg.id}`,
        method: "POST",
        body: queryArg.appraisalQuestionnaire,
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole, version: queryArg.version },
      }),
    }),
    confirmQuestionnaire: build.mutation<
      ConfirmQuestionnaireApiResponse,
      ConfirmQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/confirm-questionnaire/${queryArg.id}`,
        method: "POST",
        body: queryArg.appraisalQuestionnaire,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getQuestionnaire: build.query<
      GetQuestionnaireApiResponse,
      GetQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/confirm-questionnaire/${queryArg.id}`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    requestContact: build.mutation<
      RequestContactApiResponse,
      RequestContactApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/contact-request/${queryArg.idPractice}`,
        method: "POST",
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    notifyNoContact: build.mutation<
      NotifyNoContactApiResponse,
      NotifyNoContactApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/no-contact-notification/${queryArg.idPractice}`,
        method: "POST",
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getRejectionReasonList: build.query<
      GetRejectionReasonListApiResponse,
      GetRejectionReasonListApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/rejection-reason-list/`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    rejectPractice: build.mutation<
      RejectPracticeApiResponse,
      RejectPracticeApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/reject/${queryArg.id}`,
        method: "POST",
        body: queryArg.rejectionRequest,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    sendRejectedFeedback: build.mutation<
      SendRejectedFeedbackApiResponse,
      SendRejectedFeedbackApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-activities/rejected-feedback/${queryArg.id}`,
        method: "PUT",
        headers: { Authorization: queryArg.authorization },
        params: { activeRole: queryArg.activeRole },
      }),
    }),
    getRemindersSupplierNetwork: build.query<
      GetRemindersSupplierNetworkApiResponse,
      GetRemindersSupplierNetworkApiArg
    >({
      query: (queryArg) => ({
        url: `/reminders-supplier-network`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getPracticesFromAssignmentMapByAppraiser: build.query<
      GetPracticesFromAssignmentMapByAppraiserApiResponse,
      GetPracticesFromAssignmentMapByAppraiserApiArg
    >({
      query: (queryArg) => ({
        url: `/assignment-map/appraisers/${queryArg.id}/practices`,
        headers: { Authorization: queryArg.authorization },
        params: { tenants: queryArg.tenants, idZone: queryArg.idZone },
      }),
    }),
    getAppraisersFromAssignmentMapByPractice: build.query<
      GetAppraisersFromAssignmentMapByPracticeApiResponse,
      GetAppraisersFromAssignmentMapByPracticeApiArg
    >({
      query: (queryArg) => ({
        url: `/assignment-map/practices/${queryArg.id}/appraisers`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getAssignmentMap: build.query<
      GetAssignmentMapApiResponse,
      GetAssignmentMapApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/assignment-map`,
        headers: { Authorization: queryArg.authorization },
        params: {
          practiceStatus: queryArg.practiceStatus,
          isUrgent: queryArg.isUrgent,
          tenants: queryArg.tenants,
          appraiserType: queryArg.appraiserType,
          saturationCluster: queryArg.saturationCluster,
        },
      }),
    }),
    assignPractices: build.mutation<
      AssignPracticesApiResponse,
      AssignPracticesApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/bulk-assignment`,
        method: "POST",
        body: queryArg.bulkAssignmentData,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getCoverageLevelSettings: build.query<
      GetCoverageLevelSettingsApiResponse,
      GetCoverageLevelSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/coverage-level-settings`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    setCoverageLevelSettings: build.mutation<
      SetCoverageLevelSettingsApiResponse,
      SetCoverageLevelSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/practices/coverage-level-settings`,
        method: "POST",
        body: queryArg.coverageLevelSettings,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    saveAppraiserCurrentLocation: build.mutation<
      SaveAppraiserCurrentLocationApiResponse,
      SaveAppraiserCurrentLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/appraisers/currentLocation`,
        method: "POST",
        body: queryArg.geographicalLocation,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getPracticeStatusTypes: build.query<
      GetPracticeStatusTypesApiResponse,
      GetPracticeStatusTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/practice-commons/practice-status-types`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as apiCrud };
export type AdvancedSearchApiResponse =
  /** status 200 A JSON array representing the search results */
    | {
        subject?: SubjectMainData;
        policies?: PolicyMainData[];
      }[]
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type AdvancedSearchApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Search for a generic term */
  term?: string;
  subjectType?: string;
  /** Natural person name */
  name?: string;
  /** Natural person lastname */
  lastname?: string;
  /** Natural person fiscal code */
  fiscalCode?: string;
  /** Phone number */
  phone?: string;
  /** Email */
  email?: string;
  /** Giuridical person business name */
  businessName?: string;
  /** Giuridical person vat number */
  pIva?: string;
  /** Vehicle plate number */
  plate?: string;
  /** Number of a policy */
  policyNumber?: string;
  /** Insurance company code */
  insurance?: string;
  /** Number of a claim */
  claimNumber?: string;
};
export type CreatePolicyApiResponse =
  /** status 201 The new item is created */ {
    /** New item id */
    id?: number;
    /** Confirmation message */
    message?: string;
  };
export type CreatePolicyApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** new policy data */
  policy: Policy;
};
export type CreateClaimApiResponse =
  /** status 200 A JSON representing the claim data */ Claim;
export type CreateClaimApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** New claim data */
  claim: Claim;
};
export type ReadClaimApiResponse =
  /** status 200 A JSON representing the claim data */
    | {
        claim?: Claim;
        policy?: PolicyMainData;
      }
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type ReadClaimApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
};
export type UpdateClaimApiResponse =
  /** status 200 undefined */ void | /** status 204 The request was correct but the item does not exists */ {
    /** Item not found */
    message?: string;
  };
export type UpdateClaimApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** Update a claim data */
  claim: Claim;
};
export type DeleteClaimApiResponse = /** status 200 The item is deleted */ {
  /** Deleted item id */
  id?: number;
  /** Confirmation message */
  message?: string;
};
export type DeleteClaimApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
};
export type GetPracticesSummaryApiResponse =
  /** status 200 A JSON representing the attachments */
    | DashboardSummary
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetPracticesSummaryApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
};
export type UpdatePracticesSummaryApiResponse = unknown;
export type UpdatePracticesSummaryApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
  dashboardSummary: DashboardSummary;
};
export type GetPracticesStatusApiResponse =
  /** status 200 A JSON representing the attachments */
    | PracticesProcessingStatus
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetPracticesStatusApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** list of practices' ids */
  practices: number[];
  /** the active role selected by the user */
  activeRole: string;
};
export type UpdatePracticesStatusApiResponse = unknown;
export type UpdatePracticesStatusApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  practicesProcessingStatus: PracticesProcessingStatus;
};
export type GetPracticesD2SummaryByTenantApiResponse =
  /** status 200 A JSON representing the attachments */
    | DashboardD2Summary
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetPracticesD2SummaryByTenantApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
  /** if true marks an assigned practice as a documental one */
  isDocumental?: boolean;
  /** whether a practice is assigned to an internal or external expert (appraiser) */
  appraiserType?: string;
  /** whether has been scheduled an appointment for the evaluation task */
  hasAppointment?: boolean;
  /** status id of the practices' list to be filtered */
  practiceStatus?: string;
  /** aggregation status of the practices to be filtered */
  practiceStatusAggr?: string;
};
export type UpdateD2PracticesSummaryApiResponse = unknown;
export type UpdateD2PracticesSummaryApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
  dashboardD2Summary: DashboardD2Summary;
};
export type GetPracticesE2SummaryApiResponse =
  /** status 200 A JSON representing the attachments */
    | DashboardE2Summary
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetPracticesE2SummaryApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
};
export type UpdatePracticesE2SummaryApiResponse = unknown;
export type UpdatePracticesE2SummaryApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
  dashboardE2Summary: DashboardE2Summary;
};
export type GetF1PracticesSummaryByTenantApiResponse =
  /** status 200 a JSON representing Customer's Dashboard (appraisal) */
    | DashboardF1Summary
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetF1PracticesSummaryByTenantApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
};
export type FakeUpdateF1PracticesSummaryByTenantApiResponse = unknown;
export type FakeUpdateF1PracticesSummaryByTenantApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
  dashboardF1Summary: DashboardF1Summary;
};
export type GetE4PracticesSummaryByTenantApiResponse =
  /** status 200 a JSON representing Customer's Dashboard (appraisal) */
    | DashboardE4Summary
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetE4PracticesSummaryByTenantApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
};
export type FakeUpdateE4PracticesSummaryByTenantApiResponse = unknown;
export type FakeUpdateE4PracticesSummaryByTenantApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
  dashboardE4Summary: DashboardE4Summary;
};
export type GetE1PracticesSummaryByTenantApiResponse =
  /** status 200 a JSON representing Customer's Dashboard (appraisal) */
    | DashboardE1Summary
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetE1PracticesSummaryByTenantApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
};
export type FakeUpdateE1PracticesSummaryByTenantApiResponse = unknown;
export type FakeUpdateE1PracticesSummaryByTenantApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  idTenant: number;
  dashboardE1Summary: DashboardE1Summary;
};
export type GetPracticeDetailApiResponse =
  /** status 200 A JSON representing the attachments */
    | ReadOnlyPractice
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetPracticeDetailApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
};
export type UpdatePracticeDetailApiResponse =
  /** status 200 A JSON representing the attachments */
    | ReadOnlyPractice
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type UpdatePracticeDetailApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
  /** A JSON representing the practice data to update */
  writeOnlyPractice: WriteOnlyPractice;
};
export type PracticeBlockApiResponse =
  /** status 200 A JSON representing the attachments */ ItemUpdated;
export type PracticeBlockApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
};
export type PracticeUnblockApiResponse =
  /** status 200 A JSON representing the attachments */ ItemUpdated;
export type PracticeUnblockApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
};
export type GetUserCommunicationsListApiResponse =
  /** status 200 A JSON representing the attachments */ CommunicationsList;
export type GetUserCommunicationsListApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** whether the cummunication sender is a customer or an expert (appraiser) */
  senderType: string;
  /** list of tenants by which filter the practice list */
  tenants: number[];
  /** communications' category Code */
  categoryCode?: string;
  /** communications' status Code */
  statusCode?: string;
};
export type CreateCommunicationApiResponse = unknown;
export type CreateCommunicationApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  communication: Communication;
};
export type GetAppraisersListApiResponse =
  /** status 200 A JSON representing the attachments */ {
    expertizerList?: PracticeActivityAppraiser[];
  };
export type GetAppraisersListApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  practiceId?: number;
  /** Id of the tenant */
  tenantsId?: number[];
  /** the active role selected by the user */
  activeRole: string;
};
export type UpdateAppraisersListApiResponse = unknown;
export type UpdateAppraisersListApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  practiceActivityAppraiser: PracticeActivityAppraiser;
};
export type AssignAppraiserApiResponse =
  /** status 200 A JSON representing the attachments */ ReadOnlyPractice;
export type AssignAppraiserApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** the active role selected by the user */
  activeRole: string;
  assignmentData: AssignmentData;
};
export type SuspendOrCancelPracticeApiResponse =
  /** status 200 A JSON representing the practice */ ReadOnlyPractice;
export type SuspendOrCancelPracticeApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** the active role selected by the user */
  activeRole: string;
  suspendOrCancelData: SuspendOrCancelData;
};
export type RestorePracticeApiResponse =
  /** status 200 A JSON representing the attachments */ ReadOnlyPractice;
export type RestorePracticeApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** the active role selected by the user */
  activeRole: string;
  restorePracticeData: RestorePracticeData;
};
export type CreatePracticeNoteApiResponse =
  /** status 200 A JSON representing the attachments */ {
    practiceNotes?: PracticeNote[];
  };
export type CreatePracticeNoteApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  practiceNote: PracticeNote;
};
export type UpdatePracticeNoteApiResponse =
  /** status 200 A JSON representing the attachments */ PracticeNote;
export type UpdatePracticeNoteApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  practiceNote: PracticeNote;
};
export type DeletePracticeNoteApiResponse =
  /** status 200 The item is deleted */ {
    /** Deleted item id */
    id?: number;
    /** Confirmation message */
    message?: string;
  };
export type DeletePracticeNoteApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
};
export type GetPracticeNotesApiResponse =
  /** status 200 A JSON representing the attachments */ {
    practiceNotes?: PracticeNote[];
  };
export type GetPracticeNotesApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  idPractice: number;
};
export type CreatePracticeAppointmentApiResponse =
  /** status 200 A JSON representing the attachments */ ReadOnlyPractice;
export type CreatePracticeAppointmentApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** the active role selected by the user */
  activeRole: string;
  practiceAppointment: PracticeAppointment;
};
export type AcceptPracticeAssignmentApiResponse =
  /** status 200 A JSON representing the attachments */ ReadOnlyPractice;
export type AcceptPracticeAssignmentApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  idPractice: number;
};
export type SetOutOfCoverageAreaApiResponse =
  /** status 200 A JSON representing the attachments */ ReadOnlyPractice;
export type SetOutOfCoverageAreaApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  idPractice: number;
  /** the active role selected by the user */
  activeRole: string;
  outOfCoverageAppraisalSubject: OutOfCoverageAppraisalSubject;
};
export type UpdatePracticeRatesApiResponse =
  /** status 200 A JSON representing the attachments */ ReadOnlyPractice;
export type UpdatePracticeRatesApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  idPractice: number;
  /** the active role selected by the user */
  activeRole: string;
  practiceRate: PracticeRate;
};
export type UpdatePracticeFeesApiResponse =
  /** status 200 A JSON representing the attachments */ ReadOnlyPractice;
export type UpdatePracticeFeesApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  idPractice: number;
  /** the active role selected by the user */
  activeRole: string;
  practiceFee: PracticeFee;
};
export type GetDocumentTypesApiResponse =
  /** status 200 a JSON representing a list of document types and categories */
    | AppraisalDocumentTypes
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetDocumentTypesApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** the active role selected by the user */
  activeRole: string;
};
export type UploadPracticeDocumentApiResponse =
  /** status 200 a JSON desribing a set of uploaded documents */
    | PracticeDocumentsByCategory
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type UploadPracticeDocumentApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  practiceDocument: PracticeDocument;
};
export type GetIniFileApiResponse =
  /** status 200 a JSON desribing a set of uploaded documents */
    | PracticeDocument
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetIniFileApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
};
export type GetConservativeAgreementFileApiResponse =
  /** status 200 a JSON desribing a set of uploaded documents */
    | PracticeDocument
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetConservativeAgreementFileApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
};
export type DeleteDocumentAttachmentApiResponse =
  /** status 200 a JSON desribing a set of uploaded documents */
    | PracticeDocumentsByCategory
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type DeleteDocumentAttachmentApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** numeric attachment id */
  idAttachment: number;
};
export type GetAllPracticeDocumentsApiResponse =
  /** status 200 a JSON desribing a set of uploaded documents */
    | PracticeDocumentsByCategory
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetAllPracticeDocumentsApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
};
export type GetPracticeHistoryApiResponse =
  /** status 200 a JSON describing an array of history logs */
    | PracticeHistoryList
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetPracticeHistoryApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  idPractice: number;
  /** the active role selected by the user */
  activeRole: string;
};
export type FakeUpdatePracticeHistoryApiResponse = unknown;
export type FakeUpdatePracticeHistoryApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  idPractice: number;
  practiceHistory: PracticeHistory;
};
export type GetAllPracticeRequestsApiResponse =
  /** status 200 a JSON representing user related requests */ PracticeRequests;
export type GetAllPracticeRequestsApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
};
export type CreatePracticeRequestApiResponse =
  /** status 200 a JSON representing user related requests */ PracticeRequests;
export type CreatePracticeRequestApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
  secondaryPracticeRequest: SecondaryPracticeRequest;
};
export type GetRequestListApiResponse =
  /** status 200 A JSON representing the the requests list */ RequestsList;
export type GetRequestListApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** last message (of the request) sender Type (User Profile) */
  lastMessageSenderType?: string;
  /** last message (of the request) receiver Type (User Profile) */
  lastMessageReceiverType?: string;
  /** list of tenants by which filter the practice list */
  tenants: number[];
  /** communications' category Code */
  categoryCode?: string;
  /** communications' status Code */
  statusCode?: string;
  /** the active role selected by the user */
  activeRole: string;
};
export type GetPracticeRequestApiResponse =
  /** status 200 a JSON representing user related request */ SecondaryPracticeRequest;
export type GetPracticeRequestApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
};
export type CloseRequestApiResponse = unknown;
export type CloseRequestApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
  requestMessage: RequestMessage;
};
export type ForwardRequestApiResponse = unknown;
export type ForwardRequestApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
  requestMessage: RequestMessage;
};
export type ReplyToRequestMessageApiResponse =
  /** status 200 a JSON representing user related request */ SecondaryPracticeRequest;
export type ReplyToRequestMessageApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
  requestMessage: RequestMessage;
};
export type ConfirmRequestClosureCheckApiResponse =
  /** status 200 a JSON representing user related request */ SecondaryPracticeRequest;
export type ConfirmRequestClosureCheckApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
};
export type GetAllRequestCategoryByUserRoleApiResponse =
  /** status 200 a JSON containing categories available for user's role */ RequestCategories;
export type GetAllRequestCategoryByUserRoleApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** the active role selected by the user */
  activeRole: string;
};
export type SearchPracticesBoApiResponse =
  /** status 200 A JSON array representing the search results */
    | SearchResponseBo
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type SearchPracticesBoApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** the active role selected by the user */
  activeRole: string;
  searchPracticesParams: SearchPracticesParams;
};
export type SearchPracticesAppraiserApiResponse =
  /** status 200 A JSON array representing the search results */
    | SearchResponseAppraiser
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type SearchPracticesAppraiserApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** the active role selected by the user */
  activeRole: string;
  searchPracticesParams: SearchPracticesParams;
};
export type UpdateAppraisalLocationApiResponse =
  /** status 200 A JSON object representing the practice data */
    | ReadOnlyPractice
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type UpdateAppraisalLocationApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  idPractice: number;
  /** the active role selected by the user */
  activeRole: string;
  appraisalSubject: AppraisalSubject;
};
export type GenerateCongruityReportApiResponse =
  /** status 200 A JSON object representing the practice data */
    | StringValue
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GenerateCongruityReportApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** used to finalise the practice post closure */
  version?: number;
  congruityReport: CongruityReport;
};
export type UploadAdzApiResponse =
  /** status 200 A JSON object representing the practice data */
    | AppraisalDocProcessingOutput
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type UploadAdzApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  adzUpload: AdzUpload;
};
export type FinalisePracticeApiResponse =
  /** status 200 practice successfully finalised */
    | AppraisalFinalizeResponse
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type FinalisePracticeApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
  /** used to finalise the practice post closure */
  version?: number;
  appraisalQuestionnaire: AppraisalQuestionnaire;
};
export type ConfirmQuestionnaireApiResponse =
  /** status 200 practice successfully finalised */ void | /** status 204 The request was correct but the item does not exists */ {
    /** Item not found */
    message?: string;
  };
export type ConfirmQuestionnaireApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  appraisalQuestionnaire: AppraisalQuestionnaire;
};
export type GetQuestionnaireApiResponse =
  /** status 200 A JSON representing the attachments */
    | AppraisalQuestionnaire
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetQuestionnaireApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
};
export type RequestContactApiResponse =
  /** status 200 practice successfully finalised */
    | string
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type RequestContactApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  idPractice: number;
};
export type NotifyNoContactApiResponse =
  /** status 200 practice successfully finalised */
    | string
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type NotifyNoContactApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the practice */
  idPractice: number;
};
export type GetRejectionReasonListApiResponse =
  /** status 200 a JSON representing rejection reason list data */
    | RejectionReasonList
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetRejectionReasonListApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
};
export type RejectPracticeApiResponse =
  /** status 200 a JSON representing practice data */
    | ReadOnlyPractice
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type RejectPracticeApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  rejectionRequest: RejectionRequest;
};
export type SendRejectedFeedbackApiResponse =
  /** status 200 a JSON representing practice data */
    | ReadOnlyPractice
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type SendRejectedFeedbackApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** the active role selected by the user */
  activeRole: string;
};
export type GetRemindersSupplierNetworkApiResponse =
  /** status 200 A JSON representing the reminders data of the supplier network */
    | ReminderSupplierNetwork
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetRemindersSupplierNetworkApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
};
export type GetPracticesFromAssignmentMapByAppraiserApiResponse =
  /** status 200 A JSON representing data for appraiser's related practices on map */
    | PracticesByAppraiserMapData
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetPracticesFromAssignmentMapByAppraiserApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
  /** list of tenants by which filter the practice list */
  tenants: number[];
  /** Numeric Id of the resource */
  idZone?: number;
};
export type GetAppraisersFromAssignmentMapByPracticeApiResponse =
  /** status 200 A JSON representing data for practice's related appraisers on map */
    | AppraisersByPracticeMapData
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetAppraisersFromAssignmentMapByPracticeApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** Numeric Id of the resource */
  id: number;
};
export type GetAssignmentMapApiResponse =
  /** status 200 A JSON representing data for appraisers and practices */
    | AssignmentMapData
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetAssignmentMapApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  /** status id of the practices' list to be filtered */
  practiceStatus?: string;
  /** true if practice is urgent */
  isUrgent?: boolean;
  /** list of tenants by which filter the practice list */
  tenants: number[];
  /** whether a practice is assigned to an internal or external expert (appraiser) */
  appraiserType?: string;
  /** appraiser's saturation cluster */
  saturationCluster?: string;
};
export type AssignPracticesApiResponse =
  /** status 201 The new item is created */
    | {
        /** New item id */
        id?: number;
        /** Confirmation message */
        message?: string;
      }
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type AssignPracticesApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  bulkAssignmentData: BulkAssignmentData;
};
export type GetCoverageLevelSettingsApiResponse =
  /** status 200 A JSON representing coverage level settings data */
    | CoverageLevelSettings
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetCoverageLevelSettingsApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
};
export type SetCoverageLevelSettingsApiResponse =
  /** status 200 A JSON representing coverage level settings data */
    | CoverageLevelSettings
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type SetCoverageLevelSettingsApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  coverageLevelSettings: CoverageLevelSettings;
};
export type SaveAppraiserCurrentLocationApiResponse =
  /** status 201 The new item is created */
    | {
        /** New item id */
        id?: number;
        /** Confirmation message */
        message?: string;
      }
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type SaveAppraiserCurrentLocationApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
  geographicalLocation: GeographicalLocation;
};
export type GetPracticeStatusTypesApiResponse =
  /** status 200 A JSON representing coverage level settings data */
    | string[]
    | /** status 204 The request was correct but the item does not exists */ {
        /** Item not found */
        message?: string;
      };
export type GetPracticeStatusTypesApiArg = {
  /** The JSON Web Token  that confirms the successfull authentication of the user on the frontend */
  authorization: string;
};
export type SubjectMainData = {
  /** Subject id */
  id?: number;
  /** Subject type */
  subjectType?: string;
  /** Subject name */
  name?: string;
  /** Subject lastname */
  lastname?: string;
  /** Subject fiscal code */
  fiscalCode?: string;
  /** Name of the giuridical subject */
  businessName?: string;
  /** Type of giuridical subject */
  giuridicalType?: string;
  /** VAT number of the giuridical subject */
  pIva?: string;
} | null;
export type ClaimMainDataCreated = {
  /** Claim id */
  id?: number;
  /** Claim number */
  number?: string;
  /** Date of occurrence */
  occurrenceDate?: string;
  /** Time of occurrence */
  occurrenceTime?: string;
};
export type ClaimMainData = {
  created?: ClaimMainDataCreated;
  received?: ClaimMainDataCreated;
};
export type VehicleMainData = {
  /** Vehicle id */
  id?: number;
  /** Type of vehicle */
  type?: string;
  /** Vehicle plate number */
  plateNumber?: string;
  /** Vehicle plate format */
  plateFormat?: string;
};
export type PolicyMainData = {
  /** Policy id */
  id?: number;
  /** Policy number */
  number?: string;
  /** Policy date of effect */
  effectDate?: string;
  /** Policy date of expiration */
  expirationDate?: string;
  claims?: ClaimMainData[];
  vehicle?: VehicleMainData;
  /** Insurance company code */
  insuranceCompanyCode?: string;
  owner?: SubjectMainData;
  contractor?: SubjectMainData;
};
export type ResponseError = {
  /** Error code */
  errorCode?: string;
  /** Error message */
  errorMessage?: string;
};
export type InsuredProperty = {
  id?: number;
  /** vehicle's plate number */
  plateNumber?: string;
  /** vehicle's registration year */
  registrationYear?: number;
  universalClass?: string;
  /** vehicle's type */
  vehicleTypeCode?: string;
  /** vehicle's chassis number */
  chassisNumber?: string;
  /** vehicle's brand */
  brand?: string;
  /** vehicle's model */
  modelName?: string;
  /** vehicle's model version */
  modelVersionCode?: string;
  /** vehicle's power supply type */
  fuelTypeCode?: string;
  /** vehicle's commercial value */
  commercialValue?: number;
  /** vehicle's registration date */
  registrationDate?: string;
  /** vehicle's date of purchase */
  purchaseDate?: string;
  /** vehicle's power expressed in kw */
  vehiclePowerKw?: number;
  /** vehicle's weight */
  vehicleWeight?: number;
};
export type PolicyGuarantee = {
  id?: number;
  /** type of the guarantee added to policy */
  guaranteeCode?: string;
  /** issuing date of the guarantee */
  issueDate?: string;
  /** expiration date of the guarantee */
  expirationDate?: string;
  /** maximum number of claims covered by the guarantee annually */
  annualClaimsNumber?: number;
  /** maximum amount of compensation covered by guarantee (injuried person) */
  maximumAmountPeople?: number;
  /** maximum amount of compensation covered by guarantee (damaged properties) */
  maximumAmountProperty?: number;
  /** maximum amount of compensation covered by guarantee */
  maximumAmount?: number;
  /** excess amount */
  excessAmount?: number;
  /** overdraft amount */
  overdraftAmount?: number;
  /** overdraft percentage */
  overdraftPercentage?: number;
  /** charge type defined in the guarantee */
  chargeType?: string;
};
export type BirthDateAndPlace = {
  /** Date of birth */
  date?: string;
  /** City of birth */
  city?: string;
  /** Province of birth */
  province?: string;
  /** Country of birth */
  country?: string;
};
export type Address = {
  /** Address id */
  id?: number;
  /** Type of address */
  type?: string;
  /** Street name */
  street?: string;
  /** Civic number */
  civic?: string;
  /** Postal code */
  postalCode?: string;
  /** City name */
  city?: string;
  /** Province name */
  province?: string;
  /** Country name */
  country?: string;
  /** Address latitude */
  latitude?: number;
  /** Address longitude */
  longitude?: number;
  /** If this is the preferred address */
  preferred?: boolean;
  /** true if address is active */
  isDeleted?: boolean;
  /** true if address cannot be geolocalised */
  isIncorrect?: boolean;
};
export type Contact = {
  /** Contact id */
  id?: number;
  /** Contact type */
  type?: string;
  /** Contact info details */
  value?: string;
  /** Description of the this contact */
  description?: string;
  /** Type of use case of this contact */
  useCase?: string;
  /** If this is the preferred contact of this type */
  preferred?: boolean;
  /** true if contact is active */
  isDeleted?: boolean;
};
export type SubjectDocument = {
  /** Document id */
  id?: number;
  /** codeType of document */
  documentCode?: string;
  /** Type of document */
  type?: string;
  /** Number of the document */
  number?: string;
  /** Date of issue of the document */
  issuingDate?: string;
  /** Expiration date of the document */
  expirationDate?: string;
  /** Organization that issued the document */
  issuingInstitution?: string;
};
export type SubjectPayment = {
  /** Payment id */
  id?: number;
  /** Type of payment */
  type?: string;
  /** IBAN bank account */
  iban?: string | null;
  /** BIC or Swift */
  bicSwift?: string | null;
  addressSendCheck?: Address;
  /** If this is the preferred payment method */
  preferred?: boolean;
};
export type Subject = {
  /** Subject id */
  id?: number;
  /** Subject type */
  subjectType?: string;
  /** Name of the subject */
  name?: string;
  /** Lastname of the subject */
  lastname?: string;
  /** Gender of the subject */
  gender?: string;
  /** Fiscal code of the subject */
  fiscalCode?: string;
  /** Details of the birth of the natural subject */
  birth?: BirthDateAndPlace;
  /** Name of the giuridical subject */
  businessName?: string;
  /** Type of giuridical subject */
  giuridicalType?: string;
  registeredOffice?: Address;
  /** VAT number of the giuridical subject */
  pIva?: string;
  /** Contact list */
  contacts?: Contact[] | null;
  /** Addresses List */
  addresses?: Address[] | null;
  /** Documents List */
  documents?: SubjectDocument[] | null;
  /** Payment methods List */
  payments?: SubjectPayment[] | null;
};
export type PolicySubject = {
  id?: number;
  /** Subject Role to the Policy */
  rolePolicyType?: string;
  subject?: Subject;
};
export type Policy = {
  /** Policy id */
  id?: number;
  /** Policy number */
  number?: string;
  /** Code of the insurance company */
  insuranceCompanyCode?: string;
  /** Policy branch */
  branch?: string;
  /** Policy date of effect */
  effectDate?: string;
  /** Policy date of expiration */
  expirationDate?: string;
  exclusiveDrive?: boolean;
  blackBoxPresence?: boolean;
  insuredProperties?: InsuredProperty[];
  guarantees?: PolicyGuarantee[];
  policySubjects?: PolicySubject[];
};
export type CardWizardData = {
  /** Number of vehicles involved */
  numberOfVehicles?: number;
  /** Type of the first vehicle */
  typeVehicle1?: string;
  /** Type of the second vehicle */
  typeVehicle2?: string;
  /** If there was a collision */
  collision?: boolean;
  /** If the collision was in Italy, Vatican or San Marino */
  italianPeninsula?: boolean;
};
export type Responsibility = {
  /** Code of responsibility case */
  rightWrongCode?: string;
  /** The percentage of responsibility value */
  responsibilityPercentage?: string;
  /** Barems code of vehicle A */
  baremsCodeA?: string;
  /** Barems code of vehicle B */
  baremsCodeB?: string;
  /** Reason forcing responsability */
  forcedReason?: string;
  /** Type of signature (single or double) */
  signatureType?: string;
};
export type DamagedPerson = {
  /** Person related with the damage */
  person?: SubjectMainData;
  /** List of subject's wounded parts */
  woundedParts?: string[];
  /** A note about the subject's damages */
  note?: string;
};
export type DamagedVehicle = {
  /** Type of vehicle */
  vehicleType?: string;
  /** Plate of the vehicle */
  plate?: string;
  /** The format of the plate number [ITALIAN | OTHERS] */
  plateFormat?: string;
  /** Vehicle's collision points */
  collisionPoints?: string[];
  /** A note about the vehicle's damages */
  note?: string;
};
export type DamagedProperty = {
  /** A note about the damaged property */
  note?: string;
};
export type Damage = {
  /** Type of damage [PERSON | VEHICLE | PROPERTY] */
  type?: string;
  damagedPerson?: DamagedPerson;
  damagedVehicle?: DamagedVehicle;
  damagedProperty?: DamagedProperty;
};
export type AttachmentFile = {
  id?: number;
  /** attachemt's filename (usually renamed according to the use case convention) */
  name?: string;
  /** attachemt's filename */
  originalName?: string;
  documentBasePath?: string;
  /** file's content in base64 format */
  base64File?: string;
};
export type DamagedPartAdditionalInfo = {
  /** additional info id */
  id?: number;
  /** type of additional info */
  type?: string;
  /** description of the additional info */
  description?: string;
  subject?: SubjectMainData;
  /** the role of the subject */
  subjectRole?: string;
  document?: SubjectDocument;
  /** document's attachments */
  documentAttachments?: AttachmentFile[];
  payment?: SubjectPayment;
  contact?: Contact;
};
export type DamagedPart = {
  /** Damaged part number */
  number?: string;
  /** Subject relate to the damaged part */
  subject?: SubjectMainData;
  /** Role of the damaged parts [CP | CN | TP | TN | NP | TD] */
  role?: string;
  damages?: Damage[];
  additionalInfo?: DamagedPartAdditionalInfo[];
};
export type Claim = {
  /** Claim ID */
  id?: number;
  /** Status of the claim */
  status?: string;
  cardWizardData?: CardWizardData;
  /** claim's branch code */
  claimsBranchCode?: string;
  /** Claim number */
  number?: string;
  /** Claim registration number */
  registrationDate?: string;
  /** Date of receipt of the claim */
  receiptDate?: string;
  /** Date of receipt of the claim by the insurance company */
  dateOfReceiptCompany?: string;
  /** Date of receipt of the claim by Dekra */
  dateOfReceiptDekra?: string;
  /** Date of occurrence of the accident */
  occurrenceDate?: string;
  /** Time of occurrence of the accident */
  occurrenceTime?: string;
  /** Place of occurrence of the accident */
  occurrencePlace?: Address;
  /** If the police intervened */
  policeIntervention?: boolean;
  /** If there are witnesses */
  witnesses?: boolean;
  /** Possible notes */
  note?: string;
  /** Counterpart insurance code */
  companyCodeCounterpart?: string;
  /** Subject type [PF | PG] */
  ownerSubjectTypeCodeCounterpart?: string;
  /** Subject natural person first name */
  ownerFirstNameCounterpart?: string;
  /** Subject natural person lastname */
  ownerLastNameCounterpart?: string;
  /** Subject giurical person business name */
  ownerBusinessNameCounterpart?: string;
  /** Driver first name */
  driverFirstNameCounterpart?: string;
  /** Driver lastname */
  driverLastNameCounterpart?: string;
  /** Counterpart's vehicle plata number */
  plateNumberCounterpart?: string;
  /** responsibility */
  responsibility?: Responsibility;
  damagedParts?: DamagedPart[];
  policyData?: PolicyMainData;
};
export type TotalByCategory = {
  /** category label */
  category?: string;
  /** total count by category */
  total?: number;
};
export type UserRequestsSummary = {
  senderType?: string;
  recipientType?: string;
  totalsByCategory?: TotalByCategory[];
};
export type TotalByStatus = {
  /** status id (optional) */
  id?: number;
  /** status code */
  statusCode?: string;
  /** total by status */
  totalByStatusValue?: number;
};
export type CommunicationCategory = {
  /** id of the notification category */
  id?: number;
  /** category name */
  categoryCode?: string;
  /** value of the category */
  totalByCategory?: number;
  totalsByCategoryAndStatus?: TotalByStatus[];
};
export type CommunicationsBySenderTypeAndCategories = {
  senderType?: string;
  communicationsByCategory?: CommunicationCategory[];
};
export type PracticeData = {
  /** practice id */
  id?: number;
  /** practice priority */
  priority?: number;
  /** The id of the tenant */
  idTenant?: number;
  /** name of the tenant */
  clientName?: string;
  /** The claim number */
  claimNumber?: string;
  /** A code representing the claim branch */
  claimsBranchCode?: string;
  /** A code representing the claim branch group (i.e. RCA/CVT) */
  claimsBranchGroup?: string;
  /** The plate number of the vehicle */
  plateNumber?: string;
  /** Whether the practice is urgent or not */
  isUrgent?: boolean;
  /** The practice number */
  practiceNumber?: string;
  /** The practice number used in the client company */
  practiceNumberCompany?: string;
  /** A code representing the vehicle type */
  vehicleTypeCode?: string;
  /** Issuing date of the practice */
  practiceDate?: string;
  /** Expiration date of the practice */
  expirationDate?: string;
  /** The city of the claim */
  claimCity?: string;
  /** The country of the claim */
  claimCountry?: string;
  /** The province of the claim */
  claimProvince?: string;
  /** The postal code of the claim */
  claimPostalCode?: string;
  /** The name of the appraiser */
  appraiser?: string;
  /** A code representing the practice status */
  status?: string;
  /** A code representing the aggregate practice status */
  practiceStatusAggr?: string;
  /** se è stato fissato un appuntamento per la pratica */
  isAppointment?: boolean;
  /** Appointment date for the practice */
  appointmentDate?: string;
  appraisalLocationAddress?: Address;
  /** se la pratica è aperta in modifica da un qualche utente (readonly) */
  isBlocked?: boolean;
  /** userid that has the practice opened in edit mode */
  blockingUserId?: number;
  /** expiration date set by customer (??) */
  expirationDateClient?: string;
  practiceTypeCode?: string;
  /** Data scadenza perito */
  expirationDateAppraiser?: string;
  /** appraiser priority [1 = Urgente | 2 = Importanti | 3 = In Scadenza | 4 = Scadute | 5 = Standard] */
  priorityAppraiser?: number;
  isNegative?: boolean;
  /** vehicle's chassis number */
  chassisNumber?: string;
};
export type PracticeList = PracticeData[];
export type RegisteredLetterError = {
  /** practice's id */
  idPractice?: number;
  /** Appraisal practice number */
  practiceNumber?: string;
  fileContent?: string;
  /** date of registered letter error */
  errorDate?: string;
};
export type DashboardSummary = {
  /** tenant's unique identifier */
  tenantId?: number;
  /** name of the tenant */
  clientName?: string;
  /** customer's total practices in TPA */
  totalPractices?: number;
  /** customer's total practices in TPA */
  totalDailyPractices?: number;
  /** customer's total practices in TPA */
  totalAssignedPractices?: number;
  /** customer's total practices in TPA */
  totalDiscardedPractices?: number;
  /** Tenant's total practices to be managed */
  practicesToManage?: {
    /** Total number of practices */
    total?: number;
    /** Number of urgent practices */
    urgent?: {
      /** Number of urgent practices related to RCA */
      rca?: number;
      /** Number of urgent practices related to CVT */
      cvt?: number;
    };
    /** Number of practices with an approaching expiration date */
    due?: {
      /** Number of due practices related to RCA */
      rca?: number;
      /** Number of due practices related to CVT */
      cvt?: number;
    };
    /** Number of new practices */
    new?: {
      /** Number of new practices related to RCA */
      rca?: number;
      /** Number of new practices related to CVT */
      cvt?: number;
    };
    /** Number of new practices */
    suspended?: {
      /** Number of suspended practices related to RCA */
      rca?: number;
      /** Number of suspended practices related to CVT */
      cvt?: number;
    };
  };
  /** list of communication summaries by sender type */
  userRequestsSummary?: UserRequestsSummary[];
  /** list of communication summaries by sender type */
  communicationSummary?: CommunicationsBySenderTypeAndCategories[];
  practices?: PracticeList;
  /** list of registered letters errors */
  registeredLetterErrors?: RegisteredLetterError[];
};
export type PracticesProcessingStatus = {
  /** practice's id */
  practiceId?: number;
  /** practice's status code */
  practiceStatusCode?: string;
  /** shows if appraiser gives feedback to practice rejection */
  isViewed?: boolean;
  /** aggregate practice status */
  practiceAggrStatus?: string;
  /** not empty if practice has been blocked (value = UserName) */
  blockedBy?: string;
  /** userid that has the practice opened in edit mode */
  blockingUserId?: number;
}[];
export type PracticesInProgressSummary = {
  /** number of all practices currently assigned to appraisers */
  total?: number;
  /** KPIs about all practices currently assigned to appraisers (classification by Type) */
  byIsDocumentalFlag?: {
    /** KPIs about documental practices currently assigned to appraisers */
    documental?: {
      /** total number af all documental practices assigned to appraisers */
      total?: number;
      /** total number af all documental practices assigned to internal appraisers */
      assignedToInternal?: number;
      /** total number af all documental practices assigned to external appraisers */
      assignedToExternal?: number;
    };
    /** KPIs about inspective practices currently assigned to appraisers */
    inspective?: {
      /** total number af all inspective practices assigned to appraisers */
      total?: number;
      /** total number af all inspective practices assigned to internal appraisers */
      assignedToInternal?: number;
      /** total number af all inspective practices assigned to external appraisers */
      assignedToExternal?: number;
    };
  };
  /** KPI about all currently assigned practice (classification by  has appointment flag* ) */
  byHasAppointmentFlag?: {
    /** total number of currently assigned practice having a scheduled appoinment */
    yes?: number;
    /** total number of currently assigned practice not having a scheduled appoinment */
    no?: number;
  };
};
export type DashboardD2Summary = {
  dashboardSummary?: DashboardSummary;
  practicesInProgress?: PracticesInProgressSummary;
  /** KPI related to the total of practices to be verified from SALA TECNICA */
  practicesToBeVerified?: number;
  /** Total number of cancelled practices */
  practicesCancelled?: number;
};
export type RcaCvtPair = {
  /** Number of urgent practices related to RCA */
  rca?: number;
  /** Number of urgent practices related to CVT */
  cvt?: number;
};
export type PracticeBreakDown = {
  /** Number of practices in appointment */
  appointment?: RcaCvtPair;
  /** Number of practices in not appointment */
  notAppointment?: RcaCvtPair;
};
export type PracticesToManageE2 = {
  /** Total number of practices */
  total?: number;
  /** Number of urgent practices */
  urgent?: PracticeBreakDown;
  /** Number of practices with an approaching expiration date */
  due?: PracticeBreakDown;
  /** Number of new practices */
  new?: PracticeBreakDown;
  /** Number of csncelled practices */
  suspended?: PracticeBreakDown;
};
export type PracticeE2List = {
  /** practice id */
  id?: number;
  practiceNumber?: string;
  /** The practice number used in the client company */
  practiceNumberCompany?: string;
  priority?: number;
  /** name of the tenant */
  clientName?: string;
  /** Numero di sinistro */
  sxNumber?: string;
  /** A code representing the claim branch */
  sxTypology?: string;
  /** A code representing the claim branch group (i.e. RCA/CVT) */
  claimsBranchGroup?: string;
  /** A code representing the practice type */
  practicetypecode?: string;
  plate?: string;
  model?: string;
  appraisalLocationAddress?: Address;
  /** Data scadenza perito? perizia? */
  expertDeadline?: string;
  /** Stato della pratica di perizia? */
  status?: string;
  /** A code representing the aggregate practice status */
  practiceStatusAggr?: string;
  /** se è stato fissato un appuntamento per la pratica */
  isAppointment?: boolean;
  /** Appointment date for the practice */
  appointmentDate?: string;
  /** se la pratica è aperta in modifica da un qualche utente (readonly) */
  isBlocked?: boolean;
  /** userid that has the practice opened in edit mode */
  blockingUserId?: number;
  /** se la pratica è stata rifiutata */
  isRejected?: boolean;
  /** Rejection date for the practice */
  rejectionDate?: string;
  /** shows that appraiser has viewed practice rejection */
  isViewed?: boolean;
  /** timestamp related to isViewed field */
  isViewedDate?: string;
  /** appraiser priority [1 = Urgente | 2 = Importanti | 3 = In Scadenza | 4 = Scadute | 5 = Standard] */
  priorityAppraiser?: number;
  isNegative?: boolean;
  /** vehicle's chassis number */
  chassisNumber?: string;
};
export type DashboardE2Summary = {
  /** tenant's unique identifier */
  tenantId?: number;
  totalRejected?: number;
  totalConfirmationOfReceipt?: number;
  totalAppointmentToBeScheduled?: number;
  appointmentsScheduled?: number;
  appointmentsScheduledToday?: number;
  concludePractice?: number;
  totalPractices?: number;
  totalRcaPractices?: number;
  totalCvtPractices?: number;
  waitingForAgreement?: number;
  practicesToManage?: PracticesToManageE2;
  totalCommunications?: number;
  /** list of communication summaries by sender type */
  userRequestsSummary?: UserRequestsSummary[];
  /** list of communication summaries by sender type */
  communicationSummary?: CommunicationsBySenderTypeAndCategories[];
  /** list of practices */
  practices?: PracticeE2List[];
};
export type PracticeF1List = (PracticeE2List & {
  /** indicates whether the practice has been marked as Urgent by Customer (used to display related button) */
  isUrgent?: boolean;
  /** practice return datetime (timestamp) */
  returnDateTime?: string;
  appraiserName?: string;
})[];
export type DashboardF1Summary = {
  /** list of communication summaries by sender type */
  userRequestsSummary?: UserRequestsSummary[];
  /** list of communication summaries by sender type */
  communicationSummary?: CommunicationsBySenderTypeAndCategories[];
  practices?: PracticeF1List;
};
export type PracticeDataE4 = PracticeData & {
  isRejected?: boolean;
  isDocumental?: boolean;
  rejectionReasonCode?: string;
  rejectionDate?: string;
};
export type DashboardE4Summary = {
  /** list of communication summaries by sender type */
  userRequestsSummary?: UserRequestsSummary[];
  /** list of communication summaries by sender type */
  communicationSummary?: CommunicationsBySenderTypeAndCategories[];
  practiceList?: PracticeDataE4[];
  toBeVerified?: TotalByCategory[];
  negativeToBeVerified?: TotalByCategory[];
  rejectedByCategory?: TotalByCategory[];
  toBeAssigned?: TotalByCategory[];
};
export type DashboardE1Summary = DashboardE4Summary & {
  documentalByPriority?: TotalByCategory[];
};
export type AppraisalSubject = {
  /** Subject id */
  id?: number;
  /** Subject type */
  subjectType?: string;
  /** Name of the subject */
  name?: string;
  /** Lastname of the subject */
  lastname?: string;
  /** Fiscal code of the subject */
  fiscalCode?: string;
  /** Name of the giuridical subject */
  businessName?: string;
  /** VAT number of the giuridical subject */
  pIva?: string;
  /** appraisal subject email */
  email?: string;
  /** appraisal subject legal mail */
  pec?: string;
  /** appraisal subject's main telephone number */
  phone?: string;
  address?: Address;
};
export type PracticeBase = {
  /** Appraisal id */
  id?: number;
  /** Tenant of the Appraisal */
  idTenant?: number;
  /** client id of the tenant */
  clientId?: number;
  /** Appraisal practice number */
  practiceNumber?: string;
  /** Claim */
  claim?: Claim;
  /** Policy */
  policy?: Policy;
  /** practice's priority */
  priority?: number;
  /** damage type code (set by customer according to internal rules) */
  damageTypeCode?: string;
  /** Appraisal status */
  status?: string;
  /** Appraisal company number */
  practiceNumberCompany?: string;
  /** Appraisal type */
  practiceTypeCode?: string;
  /** If the Appraisal is documental */
  isDocumental?: boolean;
  /** Appraisal agreed amount */
  isAgreedAmount?: boolean;
  /** TBD */
  isCounterpart?: boolean;
  /** TBD */
  isCreditTransfert?: boolean;
  /** Issuing date of the practice */
  practiceDate?: string;
  /** Expiration date of the practice */
  expirationDate?: string;
  /** Expiration date of the practice based on defined SLA */
  expirationDateSLA?: string;
  /** Calculated from expirationDate field */
  expirationDateIvass?: string;
  /** expiration date set by customer (??) */
  expirationDateClient?: string;
  /** Return date of the practice */
  returnDateTime?: string;
  /** first date of claim's documentation submission */
  firstDocumentationDate?: string;
  /** to be reviewed with analysts */
  isClientRepair?: boolean;
  /** to be reviewed with analysts */
  isSecondPractice?: boolean;
  /** if the Appraisal is urgent */
  isUrgent?: boolean;
  /** reason of urgency "DC" = "Da Client" | "TU" = "Trasformata in urgente" | "RP" = "Ritardo Perito" */
  urgencyReason?: string;
  /** se la pratica è aperta in modifica da un qualche utente (readonly) */
  isBlocked?: boolean;
  /** userid that has the practice opened in edit mode */
  blockingUserId?: number;
  /** Compensation Adjuster first name */
  compensationAdjusterFirstName?: string;
  /** Compensation Adjuster last name */
  compensationAdjusterLastName?: string;
  /** Compensation Adjuster email */
  compensationAdjusterEmail?: string;
  /** practice's cancellation reason (ENUM) */
  cancellationReason?: string;
  /** cancellation reason related message */
  cancellationNote?: string;
  /** true if a lawyer is present */
  isLawyer?: boolean;
  owner?: AppraisalSubject;
  /** communication recipient subject (same as owner if not present) */
  communicationRecipient?: AppraisalSubject;
  /** appraisal location reference subject (same as owner if not present) */
  appraisalLocation?: AppraisalSubject;
  /** shows if a practice was transformed in documental */
  isTransformedDocumental?: boolean;
  /** shows if a practice was hold */
  isHoldRequest?: boolean;
  /** date of hold request */
  holdRequestDate?: string;
  /** commercial value of the insured property */
  commercialValue?: number;
  /** the date of the hearing */
  hearingDate?: string;
  /** practice conclusion date */
  conclusionDate?: string;
};
export type PracticeActivityPractice = {
  /** address of active location of the practice */
  location?: Address;
  /** practice number (id incarico) */
  practiceNumber?: string;
  /** sx number (numero sinistro) */
  claimNumber?: string;
  /** A code representing the claim branch */
  claimsBranchCode?: string;
  /** plate of the vehicle */
  plateNumber?: string;
};
export type Appraiser = {
  /** Address id */
  id?: number;
  /** Tenant of the Appraiser */
  idTenant?: number;
  /** Appraiser status */
  appraiserStatus?: string;
  /** number of practices managed by Appraiser in the current day */
  practiceCountDaily?: number;
  /** Maximum number of daily practices for the Appraiser */
  maxPracticeCountDaily?: number;
  /** number of practices managed by Appraiser in the current month */
  practiceCountMonthly?: number;
  /** Maximum number of monthly practices for the Appraiser */
  maxPracticeCountMonthly?: number;
  /** If Automatic Closing is enabled for the Appraiser */
  automaticClosing?: boolean;
  /** Appraisal type */
  appraisalType?: string;
  /** If  Appraiser is internal */
  isInternal?: boolean;
  /** Appraiser subject */
  subject?: Subject;
  practices?: PracticeActivityPractice[];
};
export type PracticeAppointment = {
  /** appointment's id */
  id?: number;
  /** appointment related practice id */
  idPractice?: number;
  /** assigned appraiser id */
  idAppraiser?: number;
  appointmentStatus?: string;
  /** appointment scheduled date */
  appointmentDate?: string;
  /** appointment scheduled time */
  appointmentTimeSlot?: string;
  /** appointment's notes */
  notes?: string;
};
export type PracticeRate = {
  rate?: number;
  rateType?: string;
  penaltyPercentage?: number;
  delta?: number;
  cashPercentage?: number;
  finalRate?: number;
  baseRate?: number;
  baseRateType?: string;
  basePenaltyPercentage?: number;
  baseDelta?: number;
  baseCashPercentage?: number;
  notes?: string;
};
export type PracticeFee = {
  isActive?: boolean;
  clientName?: string;
  feeType?: string;
  basicFee?: number;
  finalFee?: number;
};
export type PracticeNote = {
  /** note's id */
  id?: number;
  idUser?: number;
  idPractice?: number;
  userName?: string;
  textNote?: string;
  dateModify?: string;
};
export type ReadOnlyPractice = PracticeBase & {
  /** shows that appraiser has viewed practice rejection */
  isViewed?: boolean;
  /** timestamp related to isViewed field */
  isViewedDate?: string;
  /** shows if a practice was rejected */
  isRejected?: boolean;
  rejectionReasonCode?: string;
  rejectionReasonNote?: string;
  /** practice notes from ws */
  notes?: string;
  /** the date when the practice has changed status */
  practiceStatusDate?: string;
  /** Appraiser */
  appraiser?: Appraiser;
  relatedPractices?: PracticeList;
  appointment?: PracticeAppointment;
  rates?: PracticeRate[];
  fee?: PracticeFee;
  practiceNotes?: PracticeNote[];
  appraisalLocationHist?: (AppraisalSubject & {
    /** true if current location is checked as confirmed one */
    isActive?: boolean;
    /** date of change */
    modificationDateTime?: string;
    outOfCoverageNote?: string;
    isOutCoverage?: boolean;
  })[];
  /** list of registered letters errors for the practice */
  registeredLetterErrors?: RegisteredLetterError[];
};
export type WriteOnlyPractice = PracticeBase;
export type ItemUpdated = any;
export type Communication = {
  /** communication identifier */
  id?: number;
  /** practice's id in */
  idPractice?: number;
  /** tenant's id of the related practice */
  idTenant?: number;
  /** practice identier */
  practiceNumber?: string;
  /** communication's category code */
  categoryCode?: string;
  /** communication's status */
  statusCode?: string;
  /** sender type code (customer,expert) */
  senderType?: string;
  /** name/code of the sender user */
  sender?: string;
  /** date of submission of message by sender */
  sendingDate?: string;
  /** communication's priority */
  priorityCode?: string;
  /** message body */
  messageText?: string;
};
export type CommunicationsList = Communication[];
export type PracticeActivityAppraiser = {
  /** appraiser id */
  id?: number;
  /** Subject type */
  subjectType?: string;
  /** Name of the expertizer */
  firstName?: string;
  /** Lastname of the expertizer */
  lastName?: string;
  /** Name of the giuridical expertizer */
  businessName?: string;
  /** true if the appraiser is internal */
  isInternal?: boolean;
  /** zone id */
  idZona?: number;
  /** Postal code */
  postalCode?: string;
  /** City name */
  city?: string;
  /** Province name */
  province?: string;
  /** Appraiser status in the province */
  appraiserStatus?: string;
  /** number of practices managed by Appraiser in the current day */
  practiceCountDaily?: number;
  /** Maximum number of daily practices for the Appraiser */
  maxPracticeCountDaily?: number;
  /** number of practices managed by Appraiser in the current month */
  practiceCountMonthly?: number;
  /** Maximum number of monthly practices for the Appraiser */
  maxPracticeCountMonthly?: number;
  /** Workload of the expertizer (Occupazione) */
  workload?: string;
  /** Availability of the expertizer (Disponibilità) */
  availability?: string;
  /** Latitude of the expertizer */
  latitude?: number;
  /** Longitude of the expertizer */
  longitude?: number;
  /** Rank of the expertizer based on their work load & availability */
  rank?: number;
};
export type AssignmentData = {
  idPractice?: number;
  idAppraiser?: number;
};
export type SuspendOrCancelData = {
  idPractice?: number;
  practiceStatus?: string;
  cancellationReason?: string;
  cancellationNote?: string;
};
export type RestorePracticeData = {
  idPractice?: number;
  isUrgent?: boolean;
  urgencyReason?: string;
};
export type OutOfCoverageAppraisalSubject = AppraisalSubject & {
  outOfCoverageNote?: string;
};
export type AppraisalDocumentTypes = {
  documentTypeCode?: string;
  documentCategoryCode?: string;
}[];
export type PracticeAttachment = {
  id?: number;
  name?: string;
  originalName?: string;
  base64File?: string;
};
export type PracticeDocument = {
  id?: number;
  documentCode?: string;
  categoryTypeCode?: string;
  name?: string;
  documentTypeCode?: string;
  attachments?: PracticeAttachment[];
  version?: number;
};
export type PracticeDocumentsByCategory = PracticeDocument[];
export type Modifydetail = {
  key?: string;
  value?: string;
};
export type PracticeHistory = {
  /** practice's id */
  idPractice?: number;
  /** the type of change stored in history */
  modifyType?: string;
  /** description of the change applied */
  modifyDescription?: string;
  /** if the change has to be shown in frontend */
  isFrontend?: boolean;
  /** user author of modification */
  modifyUser?: string;
  /** date of modification */
  modifyTimestamp?: string;
  /** practice status (at change time) */
  practiceStatus?: string;
  /** appraiser's name */
  appraiser?: string;
  modifyDetailsJson?: Modifydetail[];
};
export type PracticeHistoryList = PracticeHistory[];
export type RequestMessage = {
  id?: number;
  requestId?: number;
  senderProfile?: number;
  sender?: string;
  receiverProfile?: number;
  receiver?: string;
  messageText?: string;
  messageDate?: string;
  attachedDocuments?: PracticeDocument[];
};
export type PrimaryPracticeRequest = {
  id?: number;
  isUrgent?: boolean;
  isToCheck?: boolean;
  tenantId?: number;
  practiceId?: number;
  categoryCode?: string;
  /** corresponding to the requestor profile id */
  senderProfile?: number;
  /** corresponding to user's name (firstname + lastname) */
  sender?: string;
  /** requestor's User active Role */
  senderRole?: number;
  senderId?: number;
  /** corresponding to the recipient profile id */
  recipientProfile?: number;
  status?: string;
  /** Request Title (same as request category except for the "Other" category) */
  requestObject?: string;
  /** request creation date */
  sendingDate?: string;
  messages?: RequestMessage[];
};
export type SecondaryPracticeRequest = PrimaryPracticeRequest & {
  /** if has a parent request is True */
  isSecondary?: boolean;
  primaryRequest?: PrimaryPracticeRequest;
};
export type PracticeRequests = SecondaryPracticeRequest[];
export type Request = {
  /** communication identifier */
  id?: number;
  /** practice's id in */
  idPractice?: number;
  /** tenant's id of the related practice */
  idTenant?: number;
  /** practice identier */
  practiceNumber?: string;
  /** communication's category code */
  categoryCode?: string;
  /** communication's status */
  statusCode?: string;
  /** sender type code (customer,expert) */
  senderType?: string;
  /** name/code of the sender user */
  sender?: string;
  /** date of submission of message by sender */
  sendingDate?: string;
  /** communication's priority */
  priorityCode?: string;
  /** request object */
  requestObject?: string;
  /** date of the last message */
  messageDate?: string;
  /** message body */
  messageText?: string;
};
export type RequestsList = Request[];
export type RequestCategories = {
  categoryCode?: string;
  recipientTypes?: string[];
}[];
export type SearchResponseBo = {
  totalResultCount?: number;
  results?: PracticeList;
};
export type SearchPracticesParams = {
  /** tenant's list */
  tenants?: number[];
  /** plates of the vehicles */
  plates?: string[];
  /** claim numbers of different practices */
  claimsNumber?: string[];
  /** Dekra number of the practices */
  practicesNumber?: string[];
  /** client number of the practices */
  practiceNumberCompany?: string[];
  /** A code representing the practice status */
  status?: string;
  /** starting range of practice date */
  practiceDateFrom?: string;
  /** ending range practice date */
  practiceDateTo?: string;
  /** return date from (Data Restituzione da) */
  returnDateFrom?: string;
  /** practice date to (Data Restituzione a) */
  returnDateTo?: string;
  /** appraiser id (Studio) */
  idAppraiser?: number;
  /** appraiser's name (both physical and juridical) */
  appraiserName?: string;
  /** Concordato */
  agreed?: string;
  /** A code representing the practice type */
  practiceTypeCode?: string;
  /** vehicle's chassis number */
  chassisNumber?: string[];
  /** appointment date from (Data Appuntamento da) */
  appointmentDateFrom?: string;
  /** appointment date to (Data Appuntamento a) */
  appointmentDateTo?: string;
  /** is negative (Perizia Negativa) */
  isNegative?: boolean;
};
export type SearchResponseAppraiser = {
  totalResultCount?: number;
  results?: PracticeE2List[];
};
export type StringValue = {
  value?: string;
};
export type CongruityReport = {
  filename?: string;
  textNote?: string;
};
export type DocProcessingAlert = {
  alertCode?: string;
  alertType?: string;
  alertDescription?: string;
  /** usefull info x debug */
  alertDebugInfo?: string;
};
export type AppraisalDocProcessingOutput = {
  isAutomaticChecksError?: boolean;
  isAutomaticChecksWarning?: boolean;
  isAgreementError?: boolean;
  isAgreementWarning?: boolean;
  isConservativeAgreementFile?: boolean;
  isForcedAgreement?: boolean;
  isVerbalAgreement?: boolean;
  isAccessProofFile?: boolean;
  isUneconomic?: boolean;
  agreement?: string;
  documentCode?: string;
  alerts?: DocProcessingAlert[];
};
export type AdzUpload = AttachmentFile & {
  isNegative?: boolean;
  version?: number;
};
export type AppraisalFinalizeResponse = {
  practiceStatus?: string;
};
export type DocumentFiles = {
  documentCode?: string;
  documentTypeCode?: string;
  documentBasePath?: string;
  attachmentsFiles?: AttachmentFile[];
};
export type AppraisalQuestionnaire = {
  isNegative?: boolean;
  negativeReasonCode?: string;
  accessProof?: boolean;
  isVerbalAgreement?: boolean;
  isForcedAgreement?: boolean;
  agreement?: string;
  isConsistent?: string;
  isUneconomic?: boolean;
  notes?: string;
  conclusionDate?: string;
  totalTaxableAmount?: number;
  documents?: DocumentFiles[];
};
export type RejectionReason = {
  rejectionReasonId?: number;
  /** represents rejection reason's related code */
  rejectionReasonCode?: string;
};
export type RejectionReasonList = RejectionReason[];
export type RejectionRequest = RejectionReason & {
  /** an additional comment to rejection action */
  rejectionReasonNote?: string;
  /** rejection date */
  rejectionDate?: string;
};
export type ReminderPractice = {
  id?: number;
  priority?: number;
  priorityReason?: string;
  appraiserName?: string;
  appraiserType?: string;
  practiceNumber?: string;
  receiptDate?: string;
  assigmentAppraiserDate?: string;
  appointmentDate?: string;
  delayFromExpiring?: number;
  appraiserExpringDate?: string;
  isHoldRequest?: boolean;
  status?: string;
  appraisalType?: string;
  claimType?: string;
  plate?: string;
  clientName?: string;
  claimNumber?: string;
  clientAssignemntId?: string;
  isBlocked?: boolean;
  blockedBy?: string;
};
export type ReminderSupplierNetwork = {
  practices?: ReminderPractice[];
};
export type CoverageDistrictMapData = {
  districtCode?: string;
  saturationClusterCode?: string;
  idzone?: number;
  city?: string;
  /** referred to the retrieved geo-coordinates */
  postalCode?: string;
  /** true if is live geolocalised position */
  isPosition?: boolean;
  latitude?: number;
  longitude?: number;
};
export type AppraiserMapData = {
  id?: number;
  /** appraiser's name. If natural person equal to firstname + surname, elsde business name */
  name?: string;
  /** appraiser's currently managed practices (total count) */
  totalManagedPractices?: number;
  /** appraiser's maximum daily capacity over all coverage zones */
  totalDailyCapacity?: number;
  /** appraiser's count of residual number of practices manageable in a month */
  monthlyResidual?: number;
  /** appraiser's maximum monthly capacity over all coverage zones */
  totalMonthlyCapacity?: number;
  /** appraiser's score */
  totalScore?: number;
  address?: string;
  isInternal?: boolean;
  coverageDistricts?: CoverageDistrictMapData[];
};
export type PracticeMapData = {
  id?: number;
  practiceNumber?: string;
  practiceStatus?: string;
  /** A code representing the practice type */
  practiceTypeCode?: string;
  isUrgent?: boolean;
  assignedAppraiser?: string;
  assignedAppraiserId?: number;
  receiptDate?: string;
  appraisalLocationAddress?: Address;
};
export type PracticesByAppraiserMapData = {
  appraiser?: AppraiserMapData;
  practices?: PracticeMapData[];
};
export type AppraisersByPracticeMapData = {
  practice?: PracticeMapData;
  appraisers?: AppraiserMapData[];
};
export type AssignmentMapData = {
  appraisers?: AppraiserMapData[];
  practices?: PracticeMapData[];
};
export type Assignment = {
  practiceId?: number;
  /** if true practice has to be assigned to appraiser else practice has to be cancelled */
  isToBeAssigned?: boolean;
};
export type BulkAssignmentData = {
  appraiserId?: number;
  assignments?: Assignment[];
};
export type CoverageLevel = {
  coverageLevelCode?: string;
  minValue?: number;
  maxValue?: number;
};
export type CoverageLevelSettings = {
  assignmentMapRange?: number;
  coverageLevels?: CoverageLevel[];
};
export type GeographicalLocation = {
  latitude?: number;
  longitude?: number;
};
export const {
  useAdvancedSearchQuery,
  useLazyAdvancedSearchQuery,
  useCreatePolicyMutation,
  useCreateClaimMutation,
  useReadClaimQuery,
  useLazyReadClaimQuery,
  useUpdateClaimMutation,
  useDeleteClaimMutation,
  useGetPracticesSummaryQuery,
  useLazyGetPracticesSummaryQuery,
  useUpdatePracticesSummaryMutation,
  useGetPracticesStatusQuery,
  useLazyGetPracticesStatusQuery,
  useUpdatePracticesStatusMutation,
  useGetPracticesD2SummaryByTenantQuery,
  useLazyGetPracticesD2SummaryByTenantQuery,
  useUpdateD2PracticesSummaryMutation,
  useGetPracticesE2SummaryQuery,
  useLazyGetPracticesE2SummaryQuery,
  useUpdatePracticesE2SummaryMutation,
  useGetF1PracticesSummaryByTenantQuery,
  useLazyGetF1PracticesSummaryByTenantQuery,
  useFakeUpdateF1PracticesSummaryByTenantMutation,
  useGetE4PracticesSummaryByTenantQuery,
  useLazyGetE4PracticesSummaryByTenantQuery,
  useFakeUpdateE4PracticesSummaryByTenantMutation,
  useGetE1PracticesSummaryByTenantQuery,
  useLazyGetE1PracticesSummaryByTenantQuery,
  useFakeUpdateE1PracticesSummaryByTenantMutation,
  useGetPracticeDetailQuery,
  useLazyGetPracticeDetailQuery,
  useUpdatePracticeDetailMutation,
  usePracticeBlockMutation,
  usePracticeUnblockMutation,
  useGetUserCommunicationsListQuery,
  useLazyGetUserCommunicationsListQuery,
  useCreateCommunicationMutation,
  useGetAppraisersListQuery,
  useLazyGetAppraisersListQuery,
  useUpdateAppraisersListMutation,
  useAssignAppraiserMutation,
  useSuspendOrCancelPracticeMutation,
  useRestorePracticeMutation,
  useCreatePracticeNoteMutation,
  useUpdatePracticeNoteMutation,
  useDeletePracticeNoteMutation,
  useGetPracticeNotesQuery,
  useLazyGetPracticeNotesQuery,
  useCreatePracticeAppointmentMutation,
  useAcceptPracticeAssignmentMutation,
  useSetOutOfCoverageAreaMutation,
  useUpdatePracticeRatesMutation,
  useUpdatePracticeFeesMutation,
  useGetDocumentTypesQuery,
  useLazyGetDocumentTypesQuery,
  useUploadPracticeDocumentMutation,
  useGetIniFileQuery,
  useLazyGetIniFileQuery,
  useGetConservativeAgreementFileQuery,
  useLazyGetConservativeAgreementFileQuery,
  useDeleteDocumentAttachmentMutation,
  useGetAllPracticeDocumentsQuery,
  useLazyGetAllPracticeDocumentsQuery,
  useGetPracticeHistoryQuery,
  useLazyGetPracticeHistoryQuery,
  useFakeUpdatePracticeHistoryMutation,
  useGetAllPracticeRequestsQuery,
  useLazyGetAllPracticeRequestsQuery,
  useCreatePracticeRequestMutation,
  useGetRequestListQuery,
  useLazyGetRequestListQuery,
  useGetPracticeRequestQuery,
  useLazyGetPracticeRequestQuery,
  useCloseRequestMutation,
  useForwardRequestMutation,
  useReplyToRequestMessageMutation,
  useConfirmRequestClosureCheckMutation,
  useGetAllRequestCategoryByUserRoleQuery,
  useLazyGetAllRequestCategoryByUserRoleQuery,
  useSearchPracticesBoMutation,
  useSearchPracticesAppraiserMutation,
  useUpdateAppraisalLocationMutation,
  useGenerateCongruityReportMutation,
  useUploadAdzMutation,
  useFinalisePracticeMutation,
  useConfirmQuestionnaireMutation,
  useGetQuestionnaireQuery,
  useLazyGetQuestionnaireQuery,
  useRequestContactMutation,
  useNotifyNoContactMutation,
  useGetRejectionReasonListQuery,
  useLazyGetRejectionReasonListQuery,
  useRejectPracticeMutation,
  useSendRejectedFeedbackMutation,
  useGetRemindersSupplierNetworkQuery,
  useLazyGetRemindersSupplierNetworkQuery,
  useGetPracticesFromAssignmentMapByAppraiserQuery,
  useLazyGetPracticesFromAssignmentMapByAppraiserQuery,
  useGetAppraisersFromAssignmentMapByPracticeQuery,
  useLazyGetAppraisersFromAssignmentMapByPracticeQuery,
  useGetAssignmentMapQuery,
  useLazyGetAssignmentMapQuery,
  useAssignPracticesMutation,
  useGetCoverageLevelSettingsQuery,
  useLazyGetCoverageLevelSettingsQuery,
  useSetCoverageLevelSettingsMutation,
  useSaveAppraiserCurrentLocationMutation,
  useGetPracticeStatusTypesQuery,
  useLazyGetPracticeStatusTypesQuery,
} = injectedRtkApi;
